import React, { Component } from 'react';
import SocialsList from './SocialsList';

import Button from './Button';
import { injectIntl } from 'react-intl';
import Modal from './Modal';

class Footer extends Component {
  privacyModalRef = null;
  termsModalRef = null;
  setPrivacyModalRef = ref => (this.privacyModalRef = ref);
  setTermsModalRef = ref => (this.termsModalRef = ref);

  openPrivacyModal = () => {
    this.privacyModalRef.open();
  };

  openTermsModal = () => {
    this.termsModalRef.open();
  };

  render() {
    const { intl } = this.props;

    return (
      <footer className="Footer">
        <div className="Footer__content">
          <span className="Footer__copyright">{intl.formatMessage({ id: 'copyright.text' })}</span>

          <SocialsList className="Footer__social" showLabels={false} socials={['email', 'vimeo', 'instagram']} />

          <div className="Footer__links">
            <Button onClick={this.openPrivacyModal} tLabel={'buttons.privacy'} variants={['text']} />
            <Button onClick={this.openTermsModal} tLabel={'buttons.terms'} variants={['text']} />
          </div>
        </div>

        <Modal onRef={this.setTermsModalRef} tContent={'termsHtml'} />

        <Modal onRef={this.setPrivacyModalRef} tContent={'privacyHtml'} />
      </footer>
    );
  }
}

export default injectIntl(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer.js